export default "__VITE_ASSET__DsfX3Gb5__";